import * as React from "react"
import { Text, Button, ButtonProps } from "@chakra-ui/react"
import { AiFillRedditSquare } from "react-icons/ai"

type AdditionProps = {
  onlyIcon?: boolean
}

export const RedditButton: React.FC<ButtonProps & AdditionProps> = React.memo(
  ({ onlyIcon, ...props }) => {
    return (
      <Button
        background="#ED001C"
        color="white"
        width="130px"
        marginTop="1rem"
        _active={{}}
        _hover={{}}
        _focus={{}}
        {...props}
      >
        <AiFillRedditSquare />
        {!onlyIcon && <Text marginLeft="0.5rem">Reddit</Text>}
      </Button>
    )
  }
)
